/* @flow */
import { observable, action, toJS } from 'mobx';

import { ApiModel } from 'api/ApiModel';

export type TypePropsProjects = {
  id: string,
  name: string,
  code: string,
  description: string,
  startDate: string,
  endDate: string,
  additionalInfo: string,
  status: boolean,
  tradingAccount: [],
  location: Array<*>,
  projectLead: Array<*>,
  engineers: Array<*>,
  costCentres: Array<*>,
  assets: Array<*>,
  activity: Array<*>,
};

export default class ProjectDetailsStore extends ApiModel {
  @observable details = undefined;
  @observable projectActivity: ?Array<*> = null;
  @observable loadingProjectDetails: boolean = false;
  @observable tradingAccount: Array<*> = [];
  @observable costCentres: Array<*> = [];

  @action async loadProjectDetails(id: string): Promise<void> {
    this.loadingProjectDetails = true;

    try {
      this.details = await this.api.getResource('projects/' + id);
    } catch (e) {
      console.log(e, 'catching ERRORS');
    }

    this.loadingProjectDetails = false;
  }

  @action async loadTradingAccounts(): Promise<void> {
    this.tradingAccount = await this.api.getResource('my-accounts').catch((err: string) => {
      console.log(err);
    });
  }

  accountsModel = (): Promise<*> => {
    return new Promise((resolve: Function) => {
      resolve(toJS(this.tradingAccount.data));
    });
  };

  @action async loadCostCentres(): Promise<void> {
    this.costCentres = await this.api.getResource('cost-centres').catch((err: string) => {
      console.log(err);
    });
  }

  @action changeStatus = (newStatus: string) => {
    this.details.status = newStatus;
  };

  costCenterModel = (): Promise<*> => {
    return new Promise((resolve: Function) => {
      resolve(toJS(this.costCentres.data));
    });
  };

  @action resetStore() {
    this.details = [];
    this.loadingProjectDetails = false;
  }

  @action clearDetails() {
    this.details = [];
  }
}

export type TypeProjectDetailsStore = {|
  details: Array<TypePropsProjects>,
  projectActivity: *,
  loadingProjectDetails: boolean,
  tradingAccount: [],
  loadTradingAccounts: () => {},
  accountsModel: () => {},
  loadProjectDetails: () => {},
  changeStatus: () => {},
  loadCostCentres: () => {},
  costCenterModel: () => {},
  resetStore: () => {},
  clearDetails: () => {},
|};
